<template>
  <EasyDataTable
    :headers="fields"
    :items="normGroups"
    :alternating="true"
    :rows-per-page="10000"
    :hide-rows-per-page="true"
  >
    <template #item-selected="item">
      <b-form-checkbox v-model="item.selected">
      </b-form-checkbox>
    </template>
    <template #item-buttons="item">
      <b-button
                @click.stop="$emit('beforeEdit', item)"
                size="sm"
                class="fa fa-edit"
                v-if="allowEdit">
      </b-button>
      <b-form-checkbox v-else v-model="item.selected">
      </b-form-checkbox>
    </template>
  </EasyDataTable>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'norm-group-table',
  props: {
    normGroups: {},
    allowEdit: false
  },
  computed: {
    fields() {
      var fields = [
        { value: 'name', text: this.$t('name'), sortable: true }
      ]

      if (this.allowEdit) {
        fields.push({ value: 'buttons', text: ' ' })
      } else {
        fields.push({
          value: 'selected',
          text: this.$t('privatePage.isActive'),
          sortable: true
        })
      }

      return fields
    }
  },
  methods: {
    ...mapActions('normsModule', {
      deleteNormGroup: 'deleteNormGroup'
    }),
    onDeleteNorm: function() {
      if (window.confirm(this.deleteConfirmationMessage)) {
        this.deleteNorm()
          .then(() => {
            window.alert(this.deleteMessage)
            this.$router.push('/private/normgroups')
          })
          .catch(error => {
            this.showErrorMessage(error)
          })
      }
    }
  }
}
</script>

<style scoped>
.flagItem {
  margin-right: 2px;
}

.table .table thead {
  display: none;
}

.table td,
.table th {
  vertical-align: middle !important;
}

.table .table tbody tr {
  background-color: #fff;
}
</style>
